import { Subscription } from 'rxjs';
import { IState } from './../../store/root.reducer';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'app-no-print',
  templateUrl: './no-print.component.html',
  styleUrls: ['./no-print.component.scss']
})
export class NoPrintComponent implements OnInit, OnDestroy {

  printAvailable = true;
  printSubscription: Subscription;

  constructor(private store: Store<IState>) { }

  ngOnInit() {
    this.printSubscription = this.store.pipe(select((store: IState) => store.print))
      .subscribe(printState => {
        this.printAvailable = printState.printAvailable;
      });
  }

  ngOnDestroy() {
    if (this.printSubscription) {
      this.printSubscription.unsubscribe();
    }
  }

}
